var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentise(_vm.value.type),{tag:"component",class:_vm.$style.base,style:(_vm.style),attrs:{"value":_vm.value},on:{"loaded":function($event){return _vm.$emit('loaded', $event)},"loading":function($event){return _vm.$emit('loading', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }